import React, {Component} from "react";
import PropTypes from 'prop-types'
import './index.css'

class Separator extends Component {
    static defaultProps = {
        className: null
    };

    static propTypes = {
        className: PropTypes.string
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {props} = this;
        return props.className !== nextProps.className;
    }

    render() {
        return <div className={`Separator ${this.props.className}`}></div>;
    }
}

export default Separator